import KeywordListMobile from './KeywordListMobile.vue';

export default KeywordListMobile;
